module.exports = __webpack_public_path__ + "static/tooling-banner-6e8e95d4621fce8f5cf19b60014c0f48.png";